// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { ContactFormData } from '../types';
// import { useTranslation } from '../contexts/LanguageContext';

// const ContactForm: React.FC = () => {
//   const [formData, setFormData] = useState<ContactFormData>({
//     name: '',
//     email: '',
//     subject: '',
//     message: '',
//   });

//   const [status, setStatus] = useState<{
//     type: 'idle' | 'loading' | 'success' | 'error';
//     message: string;
//   }>({
//     type: 'idle',
//     message: '',
//   });

//   const { t } = useTranslation();

//   const handleChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//   ) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     try {
//       setStatus({ type: 'loading', message: t('form.sending') });
//       // https://asmaessafi.onrender.com/api/contact

//       const response = await fetch('/api/contact', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });

//       if (!response.ok) {
//         throw new Error('Failed to send message');
//       }

//       setFormData({
//         name: '',
//         email: '',
//         subject: '',
//         message: '',
//       });

//       setStatus({
//         type: 'success',
//         message: t('form.success'),
//       });
//     } catch (error) {
//       console.error('Error sending message:', error);

//       // // Simulate successful submission for demo
//       // setStatus({
//       //   type: 'success',
//       //   message: 'Message sent successfully! I will get back to you soon.',
//       // });

//       // // Reset form after successful submission
//       // setFormData({
//       //   name: '',
//       //   email: '',
//       //   subject: '',
//       //   message: '',
//       // });

//       // In a real app with error handling:
//       setStatus({
//         type: 'error',
//         message: t('form.error'),
//       });
//     }
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.5 }}
//       className="bg-opacity-15 bg-sky-800 rounded-xl shadow-md p-6 md:p-8"
//     >
//       <h3 className="text-3xl font-semibold text-sky-600 mb-6">
//         {t('form.getInTouch')}
//       </h3>

//       {status.type === 'success' ? (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="bg-success-50 text-success-700 p-4 rounded-lg mb-6"
//         >
//           <p>{status.message}</p>
//           <button
//             onClick={() => setStatus({ type: 'idle', message: '' })}
//             className="mt-4 bg-gradient-to-r from-sky-600 via-sky-500 to-sky-700 hover:from-sky-700 hover:via-sky-600 hover:to-sky-800 text-white font-bold px-6 py-3 rounded-xl shadow-xl shadow-blue-500/25 hover:shadow-blue-500/40 hover:scale-[1.03] active:scale-95 transition-all duration-500 group text-lg mx-auto
// "
//           >
//             {t('form.sendAnother')}
//           </button>
//         </motion.div>
//       ) : (
//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <div>
//               <label htmlFor="name" className="block text-base font-medium text-white mb-1">
//                 {t('form.name')}
//               </label>
//               <input
//                 type="text"
//                 id="name"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 rounded-lg 
//          bg-sky-950 bg-opacity-65 text-white 
//          border border-transparent 
//          focus:outline-none focus:bg-sky-900 
//          focus:border-sky-600 focus:ring-2 focus:ring-sky-600 
//          shadow-sm focus:shadow-md 
//          transition duration-300 ease-in-out"
//                 placeholder={t('form.name.placeholder')}
//               />
//             </div>
//             <div>
//               <label htmlFor="email" className="block text-base font-medium text-white mb-1">
//                 {t('form.email')}
//               </label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 rounded-lg 
//          bg-sky-950 bg-opacity-65 text-white 
//          border border-transparent 
//          focus:outline-none focus:bg-sky-900 
//          focus:border-sky-600 focus:ring-2 focus:ring-sky-600 
//          shadow-sm focus:shadow-md 
//          transition duration-300 ease-in-out"
//                 placeholder={t('form.email.placeholder')}
//               />
//             </div>
//           </div>

//           <div>
//             <label htmlFor="subject" className="block text-base font-medium text-white mb-1">
//               {t('form.subject')}
//             </label>
//             <input
//               type="text"
//               id="subject"
//               name="subject"
//               value={formData.subject}
//               onChange={handleChange}
//               required
//               className="w-full px-4 py-2 rounded-lg 
//          bg-sky-950 bg-opacity-65 text-white 
//          border border-transparent 
//          focus:outline-none focus:bg-sky-900 
//          focus:border-sky-600 focus:ring-2 focus:ring-sky-600 
//          shadow-sm focus:shadow-md 
//          transition duration-300 ease-in-out"
//               placeholder={t('form.subject.placeholder')}
//             />
//           </div>

//           <div>
//             <label htmlFor="message" className="block text-base font-medium text-white mb-1">
//               {t('form.message')}
//             </label>
//             <textarea
//               id="message"
//               name="message"
//               value={formData.message}
//               onChange={handleChange}
//               required
//               rows={5}
//               className="w-full px-4 py-2 rounded-lg resize-none  bg-sky-950 bg-opacity-65  text-white 
//          border border-transparent 
//          focus:outline-none focus:bg-sky-900 
//          focus:border-sky-600 focus:ring-2 focus:ring-sky-600 
//          shadow-sm focus:shadow-md 
//          transition duration-300 ease-in-out"
//               placeholder={t('form.message.placeholder')}
//             />
//           </div>
          
//           <button
//             type="submit"
//             disabled={status.type === 'loading'}
//             className="bg-gradient-to-r from-sky-600 via-sky-500 to-sky-700 hover:from-sky-700 hover:via-sky-600 hover:to-sky-800 text-white font-bold px-6 py-3 rounded-xl shadow-xl shadow-blue-500/25 hover:shadow-blue-500/40 hover:scale-[1.03] active:scale-95 transition-all duration-500 group text-lg mx-auto
//  disabled:cursor-not-allowed"
//           >
//             {status.type === 'loading' ? t('form.sending') : t('form.submit')}
//           </button>

//           {status.type === 'error' && (
//             <p className="text-error-600 text-sm mt-2">{status.message}</p>
//           )}
//         </form>
//       )}
//     </motion.div>
//   );
// };

// export default ContactForm;


import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ContactFormData } from '../types';
import { useTranslation } from '../contexts/LanguageContext';

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState<ContactFormData>({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState<{
    type: 'idle' | 'loading' | 'success' | 'error';
    message: string;
  }>({
    type: 'idle',
    message: '',
  });

  const { t } = useTranslation();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setStatus({ type: 'loading', message: t('form.sending') });

      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
      });

      setStatus({
        type: 'success',
        message: t('form.success'),
      });
    } catch (error) {
      console.error('Error sending message:', error);

      setStatus({
        type: 'error',
        message: t('form.error'),
      });
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="relative bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 
                 shadow-2xl shadow-black/20 overflow-hidden"
    >
      {/* Premium Background Glow Effects */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 -left-32 w-96 h-96 bg-sky-500/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-indigo-500/15 rounded-full blur-3xl animate-pulse delay-700" />
        <div className="absolute inset-0 bg-gradient-to-br from-sky-600/5 via-transparent to-indigo-600/5" />
      </div>

      {/* Content */}
      <div className="relative p-8 md:p-10 lg:p-12">
        <motion.h3
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-sky-600 via-cyan-500 to-blue-500 
                     bg-clip-text text-transparent mb-8 text-center md:text-left"
        >
          {t('form.getInTouch')}
        </motion.h3>

        {status.type === 'success' ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="bg-gradient-to-r from-emerald-500/10 to-teal-500/10 
                       border border-emerald-500/20 text-emerald-300 p-8 rounded-2xl text-center"
          >
            <p className="text-xl mb-8">{status.message}</p>
            <button
              onClick={() => setStatus({ type: 'idle', message: '' })}
              className="relative inline-flex items-center justify-center px-10 py-4 
                         bg-gradient-to-r from-sky-500 to-indigo-600 
                         hover:from-sky-600 hover:to-indigo-700 
                         text-white font-semibold text-lg rounded-xl 
                         shadow-2xl shadow-sky-500/30 hover:shadow-sky-500/50 
                         transform hover:scale-105 active:scale-98 
                         transition-all duration-500 overflow-hidden group"
            >
              <span className="relative z-10">{t('form.sendAnother')}</span>
              <span className="absolute inset-0 bg-white/20 scale-0 group-hover:scale-150 
                               transition-transform duration-700 rounded-xl" />
            </button>
          </motion.div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {['name', 'email'].map((field) => (
                <motion.div
                  key={field}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 + (field === 'email' ? 0.1 : 0) }}
                >
                  <label
                    htmlFor={field}
                    className="block text-sm font-medium text-white mb-2 tracking-wide"
                  >
                    {t(`form.${field}`)}
                  </label>
                  <input
                    type={field === 'email' ? 'email' : 'text'}
                    id={field}
                    name={field}
                    value={formData[field as keyof ContactFormData]}
                    onChange={handleChange}
                    required
                    className="w-full px-5 py-4 rounded-xl 
                               bg-white/5 backdrop-blur-md text-white 
                               border border-white/10 
                               placeholder:text-primary-200
                               focus:outline-none focus:ring-2 focus:ring-sky-400/70 
                               focus:border-sky-400/50 focus:bg-sky-800 focus:bg-opacity-20
                               shadow-inner shadow-black/20
                               transition-all duration-400 ease-out"
                    placeholder={t(`form.${field}.placeholder`)}
                  />
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              <label htmlFor="subject" className="block text-sm font-medium text-white mb-2 tracking-wide">
                {t('form.subject')}
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                className="w-full px-5 py-4 rounded-xl 
                           bg-white/5 backdrop-blur-md text-white 
                           border border-white/10 
                           placeholder:text-primary-200
                           focus:outline-none focus:ring-2 focus:ring-sky-400/70 
                           focus:border-sky-400/50 focus:bg-sky-800 focus:bg-opacity-20
                           shadow-inner shadow-black/20
                           transition-all duration-400 ease-out"
                placeholder={t('form.subject.placeholder')}
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
            >
              <label htmlFor="message" className="block text-sm font-medium text-white mb-2 tracking-wide">
                {t('form.message')}
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={6}
                className="w-full px-5 py-4 rounded-xl resize-none 
                           bg-white/5 backdrop-blur-md text-white 
                           border border-white/10 
                           placeholder:text-primary-200
                           focus:outline-none focus:ring-2 focus:ring-sky-400/70 
                           focus:border-sky-400/50 focus:bg-sky-800 focus:bg-opacity-20
                           shadow-inner shadow-black/20
                           transition-all duration-400 ease-out"
                placeholder={t('form.message.placeholder')}
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="text-center"
            >
              <button
                type="submit"
                disabled={status.type === 'loading'}
                className="relative inline-flex items-center justify-center px-10 py-4
                           bg-gradient-to-r from-sky-600 via-sky-500 to-sky-700 
                           hover:from-sky-700 hover:via-sky-600 hover:to-sky-800
                           text-white font-bold text-xl rounded-2xl 
                           shadow-2xl shadow-sky-500/40 hover:shadow-sky-500/60 
                           transform hover:scale-105 active:scale-98 
                           transition-all duration-500 overflow-hidden 
                           disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:scale-100
                           group"
              >
                <span className="relative z-10">
                  {status.type === 'loading' ? t('form.sending') : t('form.submit')}
                </span>
                <span className="absolute inset-0 bg-white/20 scale-0 group-hover:scale-150 
                                 transition-transform duration-700 rounded-2xl" />
              </button>
            </motion.div>

            {status.type === 'error' && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="text-red-400 text-center text-sm mt-4"
              >
                {status.message}
              </motion.p>
            )}
          </form>
        )}
      </div>
    </motion.div>
  );
};

export default ContactForm;